module.exports = __webpack_public_path__ + "img/ht.755ffe34.png";